export const actsData = [
  {
    id: "income-tax-1961",
    name: "Income Tax Act'1961",
    description: "Detailed statutes and sections of the Income Tax Act'1961 as updated.",
    originalUrl: "https://www.incometaxindia.gov.in/web/guest/income-tax-act",
    chapters: []
  },
  {
    id: "income-tax-2025",
    name: "Income Tax Act'2025",
    description: "Detailed statutes and sections of the Income Tax Act'2025 as updated.",
    originalUrl: "https://www.incometaxindia.gov.in/web/guest/income-tax-act-20251",
    chapters: []
  },
  {
    id: "benami-property-1988",
    name: "Prohibition of Benami Property Transactions",
    description: "Detailed statutes and sections of the Prohibition of Benami Property Transactions Act as updated.",
    originalUrl: "https://www.incometaxindia.gov.in/web/guest/prohibition-of-benami-property-transactions-act-1988",
    chapters: []
  },
  {
    id: "finance-act",
    name: "Finance Act",
    description: "Detailed statutes and sections of the Finance Acts as updated.",
    originalUrl: "https://www.incometaxindia.gov.in/web/guest/finance-acts",
    chapters: []
  },
  {
    id: "gst-act-2017",
    name: "Goods and Services Tax Act, 2017",
    description: "Detailed statutes and sections of the Goods and Services Tax Act, 2017 as updated.",
    originalUrl: "https://taxinformation.cbic.gov.in/content-page/explore-act",
    chapters: []
  }
];
